export const WEB_STORE_URL = 'https://chrome.google.com/webstore/detail/listeri/hecmnnbdebmbkiafbaoodedmfkoeplge'
export const WEB_SITE_URL = 'https://www.listeri.com'
